// Prefer WebM on Chromium and recent Safari; earlier Safari records MP4 (H264/AAC).
export function getExternalCameraRecordingType(browserWindow = window) {
    const Recorder = browserWindow.MediaRecorder;
    if (!Recorder || typeof Recorder.isTypeSupported !== 'function') return null;
    return ['video/webm;codecs=vp8,opus', 'video/webm', 'video/mp4'].find(type => Recorder.isTypeSupported(type)) || null;
}

export function getExternalCameraBrowserError(browserWindow = window) {
    const navigator = browserWindow.navigator;
    const ua = navigator.userAgent || '';
    const inApp = /FBAN|FBAV|Instagram|Line\//i.test(ua);
    const chrome = ua.match(/(?:Chrome|CriOS)\/(\d+)/);
    const otherChromium = /Edg(?:e|A|iOS)?\/|OPR\/|Opera|SamsungBrowser/i.test(ua);
    const safari = /Safari\//.test(ua) && !/Chrome|CriOS|Chromium|FxiOS|Edg|OPR|Android/i.test(ua);
    const version = ua.match(/Version\/(\d+)(?:\.(\d+))?/);
    const supportedSafari = safari && version && (Number(version[1]) > 14 || (Number(version[1]) === 14 && Number(version[2] || 0) >= 1));
    const supportedChrome = chrome && Number(chrome[1]) >= 100 && !otherChromium;

    if (inApp || (!supportedChrome && !supportedSafari)) {
        return 'Use o Google Chrome 100 ou superior ou o Safari 14.1 ou superior. Abra o link diretamente no navegador, fora de aplicativos de mensagens e redes sociais.';
    }
    if (browserWindow.isSecureContext !== true) {
        return 'A câmera externa precisa de uma conexão HTTPS segura. Acesse o endereço seguro enviado pela organização.';
    }
    const media = navigator.mediaDevices;
    const Peer = browserWindow.RTCPeerConnection;
    const Sender = browserWindow.RTCRtpSender;
    if (!media || typeof media.getUserMedia !== 'function' || typeof media.enumerateDevices !== 'function' ||
        !Peer || typeof Peer.prototype.addTrack !== 'function' || typeof Peer.prototype.getSenders !== 'function' ||
        !Sender || typeof Sender.prototype.replaceTrack !== 'function' ||
        !browserWindow.RTCSessionDescription || !browserWindow.RTCIceCandidate ||
        !browserWindow.MediaStream || !browserWindow.AudioContext || !browserWindow.Blob ||
        !getExternalCameraRecordingType(browserWindow)) {
        return 'Este navegador não disponibiliza os recursos necessários para câmera, áudio, transmissão e gravação em WebM ou MP4. Atualize o Safari ou utilize o Google Chrome.';
    }
    return '';
}
